import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const onImageDropzoneInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("on-image-dropzone").default("on-image-dropzone"),
      tileId: z.string().default(""),
      tileKey: z.string().default("")
    }),
    shouldValidate: node => node.validation.acceptedTileKeys.length > 0,
    validate: (node, entry) => node.validation.acceptedTileKeys.includes(entry.tileKey),
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "PlaceItems" && context.relatedTask.answerType === "SolidItemsOnImage" && typeof item === "number") {
        const typedTask = context.relatedTask;
        const tile = typedTask.__orderedTiles[context.indexInDetails];
        const selectedDropzoneForTile = typedTask.content[item];
        if (tile && selectedDropzoneForTile) {
          return [selectedDropzoneForTile.id, {
            type: "on-image-dropzone",
            tileId: tile.id,
            tileKey: tile.itemKey
          }];
        }
      }
      return undefined;
    }
  },
  schema: z.object({
    coords: z.union([z.object({
      x: z.number(),
      y: z.number(),
      w: z.number(),
      h: z.number()
    }), z.array(z.object({
      x: z.number(),
      y: z.number()
    }))]),
    correctAnswer: z.number().nullable().default(null)
  }),
  postprocessSchemaInput(input, context) {
    const coords = Array.isArray(input.coords) ? transformPolygonToRect(input.coords) : input.coords;
    const correctTile = typeof input.correctAnswer === "number" ? context.tiles[input.correctAnswer] : null;

    //
    // STEP: Ensure that all additional tiles that are identical to the
    // accepted tiles are also included in the entire set of allowed tiles
    // for the dropzone
    //
    const acceptedTileKeys = context.tiles.filter(it => {
      switch (true) {
        case it.type === "Audio" && correctTile?.type === "Audio":
          return it.src === correctTile?.src && it.title === correctTile?.title;
        case it.type === "Image" && correctTile?.type === "Image":
          return it.src === correctTile?.src && it.title === correctTile?.title;
        case it.type === "Text" && correctTile?.type === "Text":
          return it.text === correctTile?.text;
        default:
          return false;
      }
    }).map(it => it.itemKey || it.id);
    return {
      id: `${context.taskId}-${context.index}`,
      nodeType: "on-image-dropzone-input",
      placement: {
        x: coords.x,
        y: coords.y,
        height: coords.h,
        width: coords.w
      },
      validation: {
        acceptedTileKeys
      }
    };
  }
});
function transformPolygonToRect(coords) {
  // For a polygon, we need to find the highest and lowest
  // coordinates on both the x- and y-axis
  let xMax = 0,
    xMin = Infinity,
    yMax = 0,
    yMin = Infinity;
  for (let i = -1, j = coords.length; ++i < j;) {
    const coord = coords[i];
    if (!coord) {
      continue;
    }
    xMax = Math.max(xMax, coord.x);
    xMin = Math.min(xMin, coord.x);
    yMax = Math.max(yMax, coord.y);
    yMin = Math.min(yMin, coord.y);
  }
  return {
    x: xMin,
    y: yMin,
    w: xMax - xMin,
    h: yMax - yMin
  };
}

export { onImageDropzoneInput };
//# sourceMappingURL=input.dropzone.js.map
